/* eslint-disable max-classes-per-file */

import Enum from '@/modules/core/app/models/abstracts/Enum';

export class DocumentEvent extends Enum {
  static RESIZE = 'resize';

  static SCROLL = 'scroll';
}

export class KeyboardEvent extends Enum {
  static ENTER = 'enter';

  static SHIFT = 'shift';

  static ESCAPE = 'escape';

  static DELETE = 'delete';

  static DELETE_OVERRIDE = 'delete_override';

  static TAB = 'tab';

  static TAB_OVERRIDE = 'tab_override';

  static UP_ARROW = 'up_arrow';

  static DOWN_ARROW = 'down_arrow';

  static LEFT_ARROW = 'left_arrow';

  static RIGHT_ARROW = 'right_arrow';

  static UP_ARROW_OVERRIDE = 'up_arrow_override';

  static DOWN_ARROW_OVERRIDE = 'down_arrow_override';

  static LEFT_ARROW_OVERRIDE = 'left_arrow_override';

  static RIGHT_ARROW_OVERRIDE = 'right_arrow_override';

  static CMD_C = 'cmd_c';

  static CMD_X = 'cmd_x';

  static CMD_V = 'cmd_v';

  static CMD_Z = 'cmd_z';

  static CMD_Z_OVERRIDE = 'cmd_z_override';

  static CMD_A_OVERRIDE = 'cmd_a_override';

  static CMD_S = 'cmd_s';

  static CMD_S_OVERRIDE = 'cmd_s_override';

  static CMD_FORWARD_SLASH = 'cmd_forward_slash';

  static F = 'f';

  static W = 'w';

  static I = 'i';

  static T = 't';

  static E = 'e';

  static G = 'g';

  static M = 'm';

  static R = 'r';

  static B = 'b';

  static L = 'l';

  static O = 'o';

  static P = 'p';

  static CMD_LEFT_ARROW_OVERRIDE = 'cmd_left_arrow_override';

  static CMD_RIGHT_ARROW_OVERRIDE = 'cmd_right_arrow_override';

  static SHIFT_CMD_Z = 'shift_cmd_z';

  static _metadata = {
    ENTER: { name: 'enter', value: 13, combo: false },
    SHIFT: { name: 'shift', value: 16, combo: false },
    ESCAPE: { name: 'escape', value: 27, combo: false },
    DELETE: { name: 'delete', value: 8, combo: false },
    DELETE_OVERRIDE: { name: 'delete_override', value: 8, combo: false, override: true },
    TAB: { name: 'tab', value: 9, combo: false },
    TAB_OVERRIDE: { name: 'tab_override', value: 9, combo: false, override: true },
    UP_ARROW: { name: 'up_arrow', value: 38, combo: false },
    DOWN_ARROW: { name: 'down_arrow', value: 40, combo: false },
    LEFT_ARROW: { name: 'left_arrow', value: 37, combo: false },
    RIGHT_ARROW: { name: 'right_arrow', value: 39, combo: false },
    UP_ARROW_OVERRIDE: { name: 'up_arrow_override', value: 38, combo: false, override: true },
    DOWN_ARROW_OVERRIDE: { name: 'down_arrow_override', value: 40, combo: false, override: true },
    LEFT_ARROW_OVERRIDE: { name: 'left_arrow_override', value: 37, combo: false, override: true },
    RIGHT_ARROW_OVERRIDE: {
      name: 'right_arrow_override',
      value: 39,
      combo: false,
      override: true,
    },
    CMD_C: { name: 'cmd_c', value: 67, combo: true },
    CMD_X: { name: 'cmd_x', value: 88, combo: true },
    CMD_V: { name: 'cmd_v', value: 86, combo: true },
    CMD_Z: { name: 'cmd_z', value: 90, combo: true },
    CMD_Z_OVERRIDE: { name: 'cmd_z_override', value: 90, combo: true, override: true },
    CMD_A_OVERRIDE: { name: 'cmd_a_override', value: 65, combo: true, override: true },
    CMD_S: { name: 'cmd_s', value: 83, combo: true },
    CMD_S_OVERRIDE: { name: 'cmd_s_override', value: 83, combo: true, override: true },
    CMD_FORWARD_SLASH: { name: 'cmd_forward_slash', value: 191, combo: true },
    F: { name: 'f', value: 70 },
    W: { name: 'w', value: 87 },
    I: { name: 'i', value: 73 },
    T: { name: 't', value: 84 },
    E: { name: 'e', value: 69 },
    G: { name: 'g', value: 71 },
    M: { name: 'm', value: 77 },
    R: { name: 'r', value: 82 },
    B: { name: 'b', value: 66 },
    L: { name: 'l', value: 76 },
    O: { name: 'o', value: 79 },
    P: { name: 'p', value: 80 },
    CMD_LEFT_ARROW_OVERRIDE: {
      name: 'cmd_left_arrow_override',
      value: 37,
      combo: true,
      override: true,
    },
    CMD_RIGHT_ARROW_OVERRIDE: {
      name: 'cmd_right_arrow_override',
      value: 39,
      combo: true,
      override: true,
    },
    SHIFT_CMD_Z: { name: 'shift_cmd_z', value: 90, combo: true, needsShiftKey: true },
  };

  /**
   *
   * @param eventName
   * @returns {*}
   */
  static getEventsMetadata(eventName) {
    return this._metadata[eventName.toUpperCase()];
  }

  static getReadableShortcutInfo(eventName) {
    const key = this._metadata[eventName.toUpperCase()];
    const rep = AsciiValueRepresentation[key.value];
    const result = [];
    if (key.combo) {
      result.push({
        type: KeyRepresentationType.TEXT,
        value: 'Cmd',
      });
    }
    if (key.needsShiftKey) {
      result.push({
        type: KeyRepresentationType.TEXT,
        value: 'Shift',
      });
    }
    if (rep) {
      if (rep.startWith('ti')) {
        result.push({
          type: KeyRepresentationType.ICON,
          value: rep,
        });
      } else {
        result.push({
          type: rep.length === 1 ? KeyRepresentationType.CHAR : KeyRepresentationType.TEXT,
          value: rep,
        });
      }
    } else {
      result.push({
        type: KeyRepresentationType.CHAR,
        value: String.fromCharCode(key.value),
      });
    }
    return result;
  }
}

export const KeyRepresentationType = {
  ICON: 'icon',
  TEXT: 'text',
  CHAR: 'char',
};

export const AsciiValueRepresentation = {
  8: 'Del',
  9: 'Tab',
  13: 'Enter',
  27: 'Esc',
  37: 'ti-arrow-back',
  38: 'ti-arrow-up',
  39: 'ti-arrow-forward',
  40: 'ti-arrow-down',
  191: '/',
};

export const TextEditorType = {
  CLASSIC: 'classic',
  BALLOON: 'balloon',
  INLINE: 'inline',
};

export const SummerNoteDefaultOptions = {
  toolbar: [
    ['headline', ['style']],
    ['fontface', ['fontname']],
    ['textsize', ['fontsize']],
    ['fontclr', ['color']],
    ['style', ['bold', 'italic', 'underline', 'clear']],
    ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
    ['height', ['height']],
    ['table', ['table']],
    ['insert', ['link', 'picture', 'video']],
    ['view', ['fullscreen', 'codeview']],
    ['edit', ['undo', 'redo']],
    ['help', ['help']],
  ],
  dialogsInBody: true,
  disableResizeEditor: true,
  maximumImageFileSize: 5242880,
  codeviewFilter: false,
  fontNames: [
    'Arial',
    'Arial Black',
    'Comic Sans MS',
    'Courier New',
    'Helvetica Neue',
    'Helvetica',
    'Impact',
    'Lato',
    'Lucida Grande',
    'Tahoma',
    'Times New Roman',
    'Verdana',
    'Mulish',
  ],
  fontNamesIgnoreCheck: [
    'Arial',
    'Arial Black',
    'Comic Sans MS',
    'Courier New',
    'Helvetica Neue',
    'Helvetica',
    'Impact',
    'Lato',
    'Lucida Grande',
    'Tahoma',
    'Times New Roman',
    'Verdana',
    'Mulish',
  ],
};

export const DISPLAY_STYLE = {
  NONE: 'none',
  BLOCK: 'block',
};

export const MEDIA_WIDGET_STYLES = {
  media: {
    display: 'block',
  },
  title: {
    display: 'flex',
  },
  es: {},
  COMMON: {
    boxSizing: 'border-box',
    color: 'rgb(0, 0, 0)',
    fontFamily: 'Mulish',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '21px',
    margin: '0px',
    padding: '0px',
    textRendering: 'optimizelegibility',
    textSizeAdjust: '100%',
    userSelect: 'text',
    width: '100%',
  },
  CONSTANTS: {
    BLACK: 'rgb(0, 0, 0)',
    ES: 'es',
    MEDIA: 'media',
    STYLE_ELEMENT: '<style',
    STYLESHEET: 'rel="stylesheet"',
    YOUTUBE_COM: 'www.youtube.com',
    YOUTUBE_EMBED: 'www.youtube.com/embed/',
    YOUTUBE_THUMBNAIL_URL: 'https://i1.ytimg.com/vi/',
    YOUTUBE_THUMBNAIL_IMG: '/hqdefault.jpg',
    TITLE: 'title',
    WHITE: 'rgb(255, 255, 255)',
  },
};

export const overflowStyles = {
  VISIBLE: 'visible',
  HIDDEN: 'hidden',
  SCROLL: 'scroll',
  AUTO: 'auto',
  OVERFLOW: 'overflow',
  OVERFLOW_X: 'overflow-x',
  OVERFLOW_Y: 'overflow-y',
  OVERFLOW_SCROLL: 'overflow-scroll',
  OVERFLOW_HIDDEN: 'overflow-hidden',
  OVERFLOW_AUTO: 'overflow-auto',
  OVERFLOW_VISIBLE: 'overflow-visible',
  OVERFLOW_SCROLL_X: 'overflow-scroll-x',
  OVERFLOW_SCROLL_Y: 'overflow-scroll-y',
  OVERFLOW_SCROLL_HIDDEN: 'overflow-scroll-hidden',
};
